import { DocumentTempSaveRequest } from "apis/data-contracts";
import { useSaveTempDocumentMutation } from "../mutations/useSaveTempDocumentMutation";

export interface DocumentTempSaveRequestWithAny
  extends Omit<DocumentTempSaveRequest, "documentData"> {
  documentData: Record<string, any>;
}

export interface SaveTempDocProps {
  saveRequest: DocumentTempSaveRequestWithAny;
  successCallback?: (documentUuid: string) => void;
}

export interface UpdateTempDocProps extends SaveTempDocProps {
  documentUuid: string;
}

const useSaveTempDoc = () => {
  const saveTempDocumentMutation = useSaveTempDocumentMutation();

  function saveTempDoc({ saveRequest, successCallback }: SaveTempDocProps) {
    saveTempDocumentMutation.mutate(saveRequest, {
      onSuccess: (res) => {
        const documentUuid = res.data.result;

        if (successCallback) successCallback(documentUuid);
      },
    });
  }

  return {
    saveTempDoc,
  };
};

export default useSaveTempDoc;
